import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oscararmstrong/node/ignission/src/app/_components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/src/app/globals.css");
